import React from 'react'
import TextSubmissionStatisics from './TextSubmissionStatisics'
import CollapseAllQuestionsButton from './CollapseAllQuestionsButton'
import TextSubmissionDrawerNavigation from '../navigation/TextSubmissionDrawerNavigation'
import { Space } from 'antd'
import ViewModeSelect from './ViewModeSelect'
import { useSelector } from 'react-redux'
import { TextSubmissionTypes } from '../../../../../constants/text-submission-types'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'

const TextSubmissionDrawerExtra = () => {
    const submissionType = useSelector(assignmentSelectors.submissionType)

    return (
        <Space align='center'>
            <TextSubmissionStatisics />
            {submissionType === TextSubmissionTypes.DOCUMENT && <ViewModeSelect />}
            <CollapseAllQuestionsButton />
            <TextSubmissionDrawerNavigation />
        </Space>
    )
}

export default TextSubmissionDrawerExtra
